import { useMemo } from 'react';

import { HiddenField, HiddenSection, isHiddenField, HiddenDocumentField, HiddenDocumentSection, isHiddenDocumentField } from '../components/datasets/store';

export const useSingleHiddenFields = (currentHiddenDatasetFields: (HiddenField | HiddenSection)[]) => {
    const hiddenSingleFields = useMemo(() => currentHiddenDatasetFields.filter(field => isHiddenField(field)) as HiddenField[], [currentHiddenDatasetFields]);
    return hiddenSingleFields;
};

export const useSingleHiddenDocumentFields = (currentHiddenDatasetFields: (HiddenDocumentField | HiddenDocumentSection)[]) => {
    const hiddenSingleFields = useMemo(() => currentHiddenDatasetFields.filter(field => isHiddenDocumentField(field)) as HiddenDocumentField[], [currentHiddenDatasetFields]);
    return hiddenSingleFields;
};
